import { type IPraktikaToothCondition } from '../patient-tooth-conditions';

export interface IPraktikaPatientClinicalChartResponse {
  patient_dentition: IPraktikaPatientClinicalChart[];
}

export interface IPraktikaPatientClinicalChart {
  id: number;
  typeId: PraktikaToothType;
  toothNumber: number;
  conditions: IPraktikaToothCondition[];
}

export enum PraktikaToothType {
  Permanent = 1,
  Primary = 2,
  Missing = 3,
  Implant = 4,
  Pontic = 5,
  Denture = 6,
  ImplantDenture = 7,
  Supernumerary = 8,
}
